import React from 'react';
import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react-lite';
import { Page } from 'components';
import { userStore } from 'stores';
import SignInForm from './components';

const SignInScreen = observer(() => {
  const handleFinalSubmit = (values, responseData) => {
    userStore.saveUserData(responseData);
  };

  return (
    <Page fullScreen>
      <Grid container justify="center" alignItems="center">
        <Grid item xs={10}>
          <SignInForm onFinalSubmit={handleFinalSubmit} />
        </Grid>
      </Grid>
    </Page>
  );
});

export default SignInScreen;
